import { Form, Formik } from "formik";
import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";

import {
  toggleAccountVerificationModal,
  toggleEmailVerificationModal,
  updateAccountVerificationFrom,
  updateNewUser,
} from "@/reducers/auth";
import { _signUp, _verifyCode, _resendVerifyEmailOtp } from "@/services/auth";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";

import AuthButton from "../auth/AuthButton";
import LoginFormTopContent from "../auth/LoginFormTopContent";
import ModalPopUp from "../common/ModalPopUp";
/**
 * EmailVerificationModal component function
 *
 * @param {void}
 * @return {JSX.Element} The modal popup element
 */
const EmailVerificationModal = () => {
  const [reSending, setReSending] = useState(false);
  const dispatch = useDispatch();
  const { showEmailVerificationModal, new_user, signUpData } = useSelector(
    (state) => state.auth,
  );
  const [otp, setOtp] = useState("");
  /**
   * Function to resend the verification code.
   */
  const ResendVerificationCode = () => {
    const data = {
      email: new_user.email,
    };
    let response = _resendVerifyEmailOtp(data);
    response
      .then((res) => {
        let {
          status,
          data: { message, data },
        } = res;
        showSuccessToast(message);
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setReSending(false);
      });
  };
  return (
    <ModalPopUp show={showEmailVerificationModal} panelClass="max-w-[441px]">
      <div className="p-[21px]">
        <Formik
          initialValues={{
            verify_code: "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validateOnMount={false}
          onSubmit={(values, { setSubmitting }) => {
            if (otp.length < 4) {
              alert("Please enter a valid verification code");
              return;
            }
            const data = {
              verify_code: otp,
              user_email: new_user.email,
              user_type: new_user.type,
            };
            let response = _verifyCode(data);
            response
              .then((res) => {
                // console.log(res);
                var signUpResponse = _signUp({
                  ...signUpData,
                  is_save: "yes",
                });
                signUpResponse
                  .then((res) => {
                    // console.log(res);
                    const {
                      data: {
                        data: { registration_id },
                      },
                    } = res;
                    dispatch(
                      updateNewUser({
                        id: registration_id,
                      }),
                    );
                    dispatch(updateAccountVerificationFrom("signup"));
                    dispatch(toggleAccountVerificationModal(true));
                    dispatch(toggleEmailVerificationModal(false));
                  })
                  .catch((error) => {
                    handleAPICatch(error);
                  })
                  .finally(() => {
                    setSubmitting(false);
                  });
              })
              .catch((error) => {
                handleAPICatch(error);
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          {({ submitForm, isSubmitting, errors, touched, isValid, values }) => (
            <Form className="flex flex-col gap-6">
              <LoginFormTopContent
                title={"Email Verification"}
                titleClass="text-center"
                desc={`Please enter the verification code sent to your email address`}
                panelClass="max-w-[600px]"
              />
              <div>
                <div className="flex flex-col gap-3">
                  {/* <label htmlFor="practiceCode" className="label">
                  Verify Code <RequiredSymbol />
                </label> */}
                  <div className="grid gap-4">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={4}
                      containerStyle={"w-[228px] m-auto flex gap-4"}
                      inputType="number"
                      renderInput={(props, index) => (
                        <input
                          {...props}
                          autoFocus={index === 0 ? true : false}
                          className="h-[45px] !w-[45px] select-none !p-[0px] !shadow-[0_2px_4px_rgba(194,194,194,0.5215686275)] outline-none"
                          onKeyDown={(e) => {
                            if (index == 5 && e.keyCode == 13) {
                              submitForm();
                              if (document.activeElement != document.body)
                                document.activeElement.blur();
                            }
                          }}
                          onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                              submitForm();
                              if (document.activeElement != document.body)
                                document.activeElement.blur();
                            }
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="mt-2 text-right">
                    <p className="text-[14px] font-medium leading-[normal]">
                      Didn't receive Code?{" "}
                      <span
                        className="authLink inline-block !text-primary"
                        onClick={() => {
                          if (reSending) return;
                          setReSending(true);
                          ResendVerificationCode();
                        }}
                      >
                        {reSending ? "Resending..." : "Resend"}
                      </span>
                    </p>
                  </div>
                  {/* <div>
                  <Field
                    type="text"
                    className={`w-full h-[40px] text-black border border-bodyText bg-none autofill:bg-none autofill:shadow-none focus:shadow-none focus:ring-0 focus:border-primary focus:border rounded-lg shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor ${
                      errors.verify_code && touched.verify_code
                        ? "!border-red-500"
                        : ""
                    }`}
                    autoComplete="off"
                    name="verify_code"
                    placeholder="Enter Verify Code"
                    validate={(value) => {
                      if (!value) {
                        return "Verify Code is required";
                      }
                    }}
                    onKeyUp={(e) => {
                      if (e.keyCode === 13) {
                        submitForm();
                      }
                    }}
                    autoFocus={true}
                    autocomplete="off"
                  />
                  <FieldErrorMessage name="verify_code" />
                </div> */}
                </div>
                <AuthButton
                  submitForm={submitForm}
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                  btnText={"Verify"}
                  btnLoadingText={"Verifying..."}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </ModalPopUp>
  );
};

export default EmailVerificationModal;
